import React, { Component } from "react";
import styled from "styled-components";

import DateTime from "./DateTime/DateTime";
import NameDuration from "./NameDuration/NameDuration";
import AttendeesBoards from "./AttendeesBoards/AttendeesBoards";
import RecordingAvailability from "./RecordingAvailability/RecordingAvailability";
import ShareButton from "./ShareButton/ShareButton";
import OverFlowMenu from "./OverflowMenu/Overflow";
import { media } from "../../../UI/StyleUtils";
import CheckBox from "../../../UI/Forms/Checkbox";
import { isSampleMeeting, userIsHost } from "../../../../utility";
import { useTour } from "@reactour/tour";
import { useHistory } from "react-router-dom/cjs/react-router-dom";

const MeetingContainer = styled.div`
  height: 100%;
  margin: 0 0.5% 0 2.5%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;

  ${media.gtSm`
        margin: 0 1.25% 0 2.5%;
    `}
`;

const Meeting = (props) => {
  const dateTime = () => {
    return <DateTime time={props.startTime} />;
  };

  // TODO: Within render function, remove userIsHost check in checkbox logic after adding other non-admin bulk operations.
  const userIsHostLocal = () => {
    return userIsHost(props.hosts, props.userEmail);
  };

  const nameDuration = () => {
    return (
      <NameDuration
        id={props.id}
        name={props.meetingName}
        startTime={props.startTime}
        endTime={props.endTime}
        userIsHost={userIsHostLocal()}
        meetingNameUpdateHandler={props.meetingNameUpdateHandler}
      />
    );
  };

  const { currentStep, isOpen: isTourOpen } = useTour();
  const history = useHistory();
  if (
    currentStep === 6 &&
    isTourOpen &&
    window.location.href == `${process.env.REACT_APP_HOST}/home`
  ) {
    if (props.endTime) {
      history.push(`home/meetings/${props.id}`);
    }
  }
  return (
    <MeetingContainer id="SecondParent" className="seventh-step">
      {!isSampleMeeting(props.id) && userIsHostLocal() ? (
        <CheckBox
          // NOTE: Due to mix of redux and react component states, when the following properties are
          //      about to be set for direct meeting links from the home page, certain values from redux state are not available yet and hence local state doesn't have meeting selection data.
          //      It's not needed anyway in such use case, so we don't need to display it. Clicking on it may lead to errors.
          hidden={
            !(
              props.meetingSelectedStates &&
              props.meetingSelectedStates[props.currentPageNumber] &&
              props.meetingSelectedStates[props.currentPageNumber][props.id]
            )
          }
          fontSize="12px"
          required={true}
          isChecked={
            props.meetingSelectedStates[props.currentPageNumber] &&
              props.meetingSelectedStates[props.currentPageNumber][props.id]
              ? props.meetingSelectedStates[props.currentPageNumber][props.id][
              "checked"
              ]
              : false
          }
          onChange={(event) => {
            event.stopPropagation();
            props.onSelectMeeting(props.id);
          }}
          title="Select Meeting"
        ></CheckBox>
      ) : null}
      {dateTime()}
      {nameDuration()}
      <AttendeesBoards
        numAttendees={props.numAttendees}
        numBoards={props.numBoards}
      />
      <RecordingAvailability recordingAvailable={props.recordingAvailable} />
      <ShareButton />
      <OverFlowMenu
        {...props}
        dateTime={dateTime()}
        nameDuration={nameDuration()}
        filterByMeetingHandler={props.filterByMeetingHandler}
        singleMeetingEnable={props.singleMeetingEnable}
      />
    </MeetingContainer>
  );
};

export default Meeting;
